// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateGrantRequest } from './create-grant-request';
import {
    CreateGrantRequestFromJSON,
    CreateGrantRequestFromJSONTyped,
    CreateGrantRequestToJSON,
    CreateGrantRequestToJSONTyped,
} from './create-grant-request';

/**
 * A new study. Study fields other than studyId pass through to ingestion; grants are placed on the study once it is created.
 * @export
 * @interface CreateStudyRequest
 */
export interface CreateStudyRequest {
    /**
     * Free-text study description, passed through to ingestion
     * @type {string}
     * @memberof CreateStudyRequest
     */
    description?: string;
    /**
     * Who gets access to the new study. The creator may name themselves here; the grants API refuses self-grants.
     * @type {Array<CreateGrantRequest>}
     * @memberof CreateStudyRequest
     */
    grants: Array<CreateGrantRequest>;
    /**
     * 
     * @type {string}
     * @memberof CreateStudyRequest
     */
    studyId: string;
}

/**
 * Check if a given object implements the CreateStudyRequest interface.
 */
export function instanceOfCreateStudyRequest(value: object): value is CreateStudyRequest {
    if (!('grants' in value) || value['grants'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function CreateStudyRequestFromJSON(json: any): CreateStudyRequest {
    return CreateStudyRequestFromJSONTyped(json, false);
}

export function CreateStudyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStudyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'grants': ((json['grants'] as Array<any>).map(CreateGrantRequestFromJSON)),
        'studyId': json['studyId'],
    };
}

export function CreateStudyRequestToJSON(json: any): CreateStudyRequest {
    return CreateStudyRequestToJSONTyped(json, false);
}

export function CreateStudyRequestToJSONTyped(value?: CreateStudyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'grants': ((value['grants'] as Array<any>).map(CreateGrantRequestToJSON)),
        'studyId': value['studyId'],
    };
}
